import {
  Consent,
  consented as consentedWithoutFlag,
  deferRun as deferRunWithoutFlag,
  userHasOptedOutOfCookiesForCategory as userHasOptedOutOfCookiesForCategoryWithoutFlag
} from '@envato/cookie-consent'
import get from 'lodash-es/get'

import { configs } from '../../config/sites'

export { Consent } from '@envato/cookie-consent'

export const deferRun = (job: () => any, consent: Consent) => {
  // Global cookiebot swither
  if (get(configs, 'defaults.features.turnOffCookiebot')) {
    job()
    return
  }

  deferRunWithoutFlag(job, consent)
}

export const consented = (consent: Consent) => {
  // Global cookiebot swither
  if (get(configs, 'defaults.features.turnOffCookiebot')) {
    return true
  }

  return consentedWithoutFlag(consent)
}

export const userHasOptedOutOfCookiesForCategory = (consent: Consent) => {
  // Global cookiebot swither
  if (get(configs, 'defaults.features.turnOffCookiebot')) {
    return false
  }

  return userHasOptedOutOfCookiesForCategoryWithoutFlag(consent)
}
